import { render, staticRenderFns } from "./CalcPanel.vue?vue&type=template&id=badb8244&scoped=true&"
import script from "./CalcPanel.vue?vue&type=script&lang=js&"
export * from "./CalcPanel.vue?vue&type=script&lang=js&"
import style0 from "./CalcPanel.vue?vue&type=style&index=0&id=badb8244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badb8244",
  null
  
)

export default component.exports